/**
 * Centralized document version tracking for legal compliance.
 * All consent-related components should import from here to ensure consistency.
 * 
 * Update these versions when legal documents are modified.
 */

export const DOCUMENT_VERSIONS = {
  // Terms of Service version
  termsOfService: '2026-08-15',
  
  // Privacy Policy version
  privacyPolicy: '2026-08-15',
  
  // Cancellation Policy (Widerrufsbelehrung) version
  cancellationPolicy: '2026-08-15',
  
  // Refund Policy version
  refundPolicy: '2026-08-15',
  
  // Cookie Policy version
  cookiePolicy: '2026-04-30',
  
  // Purchase consent dialog version (combines ToS, Cancellation, Refund)
  purchaseConsent: '2026-08-15',
  
  // Copyright Policy version
  copyrightPolicy: '2026-08-15',
} as const;

export type DocumentType = keyof typeof DOCUMENT_VERSIONS;

/**
 * Get the current version of a specific document
 */
export const getDocumentVersion = (documentType: DocumentType): string => {
  return DOCUMENT_VERSIONS[documentType];
};

/**
 * Get the purchase consent version (used for all purchase-related consents)
 */
export const PURCHASE_CONSENT_VERSION = DOCUMENT_VERSIONS.purchaseConsent;

/**
 * Active changelog "what changed recently" highlight box configuration.
 *
 * Drives the in-page changelog notice on /privacy-policy and /cookie-policy
 * (see useChangelogVisibility). When `expiresAt` passes, the box stops
 * rendering automatically — no follow-up cleanup PR needed.
 *
 * When the next material privacy/cookie update lands:
 *   1. Bump `versionAnchor` to the new YYYY-MM-DD version date.
 *   2. Bump `expiresAt` to versionAnchor + 90 days.
 *   3. Add a matching CHANGELOG_COPY entry on the relevant policy page
 *      and a VERSIONED_COPY entry in PolicyUpdateBanner.
 */
export const ACTIVE_CHANGELOG = {
  versionAnchor: '2026-08-15',
  expiresAt: '2026-11-13', // versionAnchor + 90 days
} as const;
